export const styles = {
  arrowBack: {
    cursor: 'pointer',
    marginBottom: '10px',
  },
  membersBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  audienceName: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '136%',
    color: '#23252F',
  },
  membersText: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '146%',
    color: '#6E707A',
    margin: '0 0 4px 0px',
  },
};
